import { render } from "./PainelInitSC.vue?vue&type=template&id=67fa80e1&scoped=true"
import script from "./PainelInitSC.vue?vue&type=script&lang=js"
export * from "./PainelInitSC.vue?vue&type=script&lang=js"

import "./PainelInitSC.vue?vue&type=style&index=0&id=67fa80e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67fa80e1"]])

export default __exports__